/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIMeasurementRequest } from './APIMeasurementRequest';
import {
    APIMeasurementRequestFromJSON,
    APIMeasurementRequestFromJSONTyped,
    APIMeasurementRequestToJSON,
} from './APIMeasurementRequest';

/**
 * The serializer that enables the high level PartViewSet. This is basically
 * a simple form of the ArticleSerializer that is optimized to work with
 * the automated quote generation feature.
 * @export
 * @interface APIPartUpdateRequest
 */
export interface APIPartUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPartUpdateRequest
     */
    partId?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPartUpdateRequest
     */
    name?: string;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPartUpdateRequest
     */
    weight?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPartUpdateRequest
     */
    length?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPartUpdateRequest
     */
    width?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPartUpdateRequest
     */
    height?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPartUpdateRequest
     */
    volume?: APIMeasurementRequest | null;
    /**
     * 
     * @type {string}
     * @memberof APIPartUpdateRequest
     */
    manufacturingProcess: string;
    /**
     * 
     * @type {string}
     * @memberof APIPartUpdateRequest
     */
    material: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIPartUpdateRequest
     */
    treatments?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof APIPartUpdateRequest
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof APIPartUpdateRequest
     */
    qualityClass?: string;
    /**
     * The guest request that this article was created for.
     * @type {string}
     * @memberof APIPartUpdateRequest
     */
    guestRequest?: string | null;
    /**
     * 
     * @type {Blob}
     * @memberof APIPartUpdateRequest
     */
    technicalDrawing?: Blob;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIPartUpdateRequest
     */
    price?: { [key: string]: any; };
}

/**
 * Check if a given object implements the APIPartUpdateRequest interface.
 */
export function instanceOfAPIPartUpdateRequest(value: object): value is APIPartUpdateRequest {
    if (!('manufacturingProcess' in value) || value['manufacturingProcess'] === undefined) return false;
    if (!('material' in value) || value['material'] === undefined) return false;
    return true;
}

export function APIPartUpdateRequestFromJSON(json: any): APIPartUpdateRequest {
    return APIPartUpdateRequestFromJSONTyped(json, false);
}

export function APIPartUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPartUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'partId': json['part_id'] == null ? undefined : json['part_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'weight': json['weight'] == null ? undefined : APIMeasurementRequestFromJSON(json['weight']),
        'length': json['length'] == null ? undefined : APIMeasurementRequestFromJSON(json['length']),
        'width': json['width'] == null ? undefined : APIMeasurementRequestFromJSON(json['width']),
        'height': json['height'] == null ? undefined : APIMeasurementRequestFromJSON(json['height']),
        'volume': json['volume'] == null ? undefined : APIMeasurementRequestFromJSON(json['volume']),
        'manufacturingProcess': json['manufacturing_process'],
        'material': json['material'],
        'treatments': json['treatments'] == null ? undefined : json['treatments'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'qualityClass': json['quality_class'] == null ? undefined : json['quality_class'],
        'guestRequest': json['guest_request'] == null ? undefined : json['guest_request'],
        'technicalDrawing': json['technical_drawing'] == null ? undefined : json['technical_drawing'],
        'price': json['price'] == null ? undefined : json['price'],
    };
}

export function APIPartUpdateRequestToJSON(value?: APIPartUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'part_id': value['partId'],
        'name': value['name'],
        'weight': APIMeasurementRequestToJSON(value['weight']),
        'length': APIMeasurementRequestToJSON(value['length']),
        'width': APIMeasurementRequestToJSON(value['width']),
        'height': APIMeasurementRequestToJSON(value['height']),
        'volume': APIMeasurementRequestToJSON(value['volume']),
        'manufacturing_process': value['manufacturingProcess'],
        'material': value['material'],
        'treatments': value['treatments'],
        'quantity': value['quantity'],
        'quality_class': value['qualityClass'],
        'guest_request': value['guestRequest'],
        'technical_drawing': value['technicalDrawing'],
        'price': value['price'],
    };
}

